import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getTemplates } from '../utils/categoryUtils';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { MOST_POPULAR_TEMPLATE_IDS_BY_SUITE } from '../constants/popular';
import { selectReportCollectionTemplatesByKey } from '../../redux/reportCollectionTemplates';
export const useMostPopularTemplates = () => {
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const templatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const mostPopularTemplates = useMemo(() => {
    if (templatesByKey.size === 0) {
      return {};
    }
    const result = {};
    Object.entries(MOST_POPULAR_TEMPLATE_IDS_BY_SUITE).forEach(([suiteId, templateIds]) => {
      result[suiteId] = templateIds.map(templateId => {
        return getTemplates(templateId, gates, scopes, templatesByKey);
      }).flat().filter(template => template !== undefined);
    });
    return result;
  }, [gates, scopes, templatesByKey]);
  return mostPopularTemplates;
};